import * as i18n from "util/i18n";

const I18N_PREFIX = "currencyExchange.ui.";

export const getLabel = (key) => i18n.get(`${I18N_PREFIX}${key}`);

export const parseAmount = (value) => {
    if (typeof value === "number") {
        return value;
    }
    if (typeof value === "string" && value !== "") {
        return Number.parseFloat(value.replaceAll(".", "").replace(",", "."));
    }
    return 0;
};

export const formatRate = (value) => {
    if (!value) {
        return 0;
    }
    return Number(value)
        .toFixed(2)
        .replace(".", ",");
};

export const buildQuote = (rate) => {
    if (!rate) {
        return undefined;
    }
    return {
        rate: formatRate(rate),
        sourceCurrency: "ARS",
        targetCurrency: "USD",
    };
};

export const ARS_CURRENCY_CODES = new Set(["0", "01", "032"]);
export const USD_CURRENCY_CODES = new Set(["2", "02", "840"]);

export const CURRENCY_EXCHANGE_TRANSACTION_TOTAL_CURRENCY = "USD";
